import { GET_HEALTH } from '../actions/healths';

const initialState = {
  healthList: [],
  selectHealthList: [],
  healthTotalPage: 1,
  healthCurrentPage: 1,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_HEALTH.SUCCESS: {
      if (payload.data.data._meta.currentPage === 1) {
        return {
          ...state,
          selectHealthList: payload.data.data.response,
          healthList: payload.data.data.response,
          healthTotalPage: payload.data.data._meta.pageCount,
          healthCurrentPage: payload.data.data._meta.currentPage,

        };
      }
      return {
        ...state,
        healthList: payload.data.data.response,
        healthTotalPage: payload.data.data._meta.pageCount,
        healthCurrentPage: payload.data.data._meta.currentPage,
        selectHealthList: [...state.selectHealthList, ...payload.data.data.response],
      };
    }
    default:
      return state;
  }
};

export default reducer;
